<script>
module.exports = {
  props: ["categories"],
  data() {
    return {
      sortType: "10",
      selectedOption: "11",
      isHidden: false
    };
  },
  computed: {},
  methods: {
    updatePosts: function(catId) {
      this.$emit("changeCategory", catId);
    }
  }
};

let menu = document.getElementById("menu-mobile");

// Vue.component(blog , require('./button.vue'))
</script>
<template>
  <div class="menu">
    <div class="menu-desktop">
      <ul class="menulist">
        <li>
          Todos
        </li>
        <li
          v-for="(category, index) in categories"
          :key="index"
          :class="{ active: true, $category: true }"
          @click="updatePosts(category.id)"
        >
          {{ category.title }}
        </li>
      </ul>
    </div>
    <div class="menu-mobile-container">
      <ul
        v-if="!isHidden"
        id="menu-mobile"
        @click="isHidden = !isHidden"
      >
        <span> Todos </span>
      </ul>
      <ul
        v-if="isHidden"
        id="menu-mobile"
        @click="isHidden = !isHidden"
      >
        <span> Todos </span>

        <li
          v-if="isHidden"
          @click="updatePosts(10)"
        >
          Todos.
        </li>
        <li
          v-for="(category, index) in categories"
          :key="index + 'mobile'"
          :value="category.id"
          @click="updatePosts(category.id)"
        >
          {{ category.name }}
        </li>
      </ul>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.menu {
  li {
    margin: auto;
    display: flex;
    float: none;
    width: 20%;
    font-size: 1.2em;
    font-weight: bolder;
  }
  ul {
    margin: auto;
    display: flex;
    float: none;
    margin-bottom: 40px;
  }
  @media only screen and (min-width: 769px) {
    #menu-mobile {
      display: none;
    }
    .menu-desktop{
      display: block !important;
    }
  }
  @media only screen and (max-width: 769px) {
    .menu-desktop {
      display: none;
    }

    #menu-mobile {
      background-color: #5f00ff;
      color: #fff;
      display: grid;

      border-radius: 35px;
      width: 100%;
      font-size: 1.5em;
      padding: 0px;
      span {
        padding: 20px;
      }
      &:focus-within {
        border-bottom-right-radius: 0;
        border-bottom-left-radius: 0;
        li {
          display: block;
        }
      }
      li {
        width: 100%;
        background-color: #f1f1f1;
        color: #000;
        padding: 20px;
        &:last-child {
          border-bottom-right-radius: 35px;
          border-bottom-left-radius: 35px;
        }
      }
    }
  }
  @media only screen and (min-width: 769px) {
    .menu-desktop {
      display: none;
    }
  }
}
</style>
